export const PERMS = {
    READ: 'warehousing_warehouses.read',
    UPDATE: 'warehousing_warehouses.update',
    DELETE: 'warehousing_warehouses.delete',
    CREATE: 'warehousing_warehouses.create',
    EXPORT: 'warehousing_warehouses.export',
}
